import { Component } from "react"
import { connect } from "react-redux"
import { Dropdown, Modal } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import Select from "../../elements/Select"
import { Grid } from "semantic-ui-react"
import * as vehicleHelpers from "../../helpers/vehicleHelpers"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons"
import { SUCCESS } from "../../constants/notification"
import CustomNotification from "./CustomNotification"
import MiniLoader from "./MiniLoader"
import AsyncSelect from "react-select/async"
import { FILTER_OPTIONS_VEHICLE } from "../../constants/application"
import { debounce } from "lodash"

class VehicleReassignmentModal extends Component {
  state = {
    from_vehicle_id: null,
    to_vehicle_id: null,
    from_vehicle: null,
    to_vehicle: null,
    loading: false,
    from_vehicle_search_by: "vin",
    to_vehicle_search_by: "vin",
    from_vehicles_list: [],
    to_vehicles_list: []
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      from_vehicle_id: null,
      to_vehicle_id: null,
      from_vehicle: null,
      to_vehicle: null,
      loading: false,
      from_vehicle_search_by: "vin",
      to_vehicle_search_by: "vin",
      from_vehicles_list: [],
      to_vehicles_list: []
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.open !== this.props.open) {
      this.setState({
        from_vehicle_id: null,
        to_vehicle_id: null,
        from_vehicle: null,
        to_vehicle: null,
        loading: false,
        from_vehicle_search_by: "vin",
        to_vehicle_search_by: "vin",
        from_vehicles_list: [],
        to_vehicles_list: []
      })
    }
  }

  loadVehicleOptions = debounce((inputValue, callback, type) => {
    if (inputValue.length < 3) return callback([])

    const isFrom = type === "from"

    this.setState({ loading: true })

    this.loadVehicles(
      {
        query: inputValue,
        search_type: isFrom ? this.state.from_vehicle_search_by : this.state.to_vehicle_search_by
      },
      (res) => {
        const vehicles = res.vehicles ?? []

        const filtered = vehicles.filter((item) =>
          isFrom ? item.fleetcor_enrolled === true : item.fleetcor_enrolled === false
        )

        const options = vehicleHelpers.selectOptions(
          filtered,
          () => {},
          isFrom ? {} : { semantic: true }
        )

        this.setState({
          loading: false,
          [isFrom ? "from_vehicles_list" : "to_vehicles_list"]: vehicles
        })

        callback(options)
      }
    )
  }, 500)

  vehicleReassignment = () => {
    const { from_vehicle_id, to_vehicle_id } = this.state
    if (!from_vehicle_id || !to_vehicle_id) {
      CustomNotification("danger", "Error", "Both From Vehicle and To Vehicle are required")
      return
    }
    this.setState({ loading: true })
    this.props.dispatch({
      type: "VEHICLE_REASSIGNMENT_SAGA",
      payload: {
        from_vehicle_id: from_vehicle_id,
        to_vehicle_id: to_vehicle_id
      },
      callback: this.afterReassignment
    })
  }

  afterReassignment = (result) => {
    this.setState({ loading: false })
    if (result === SUCCESS) {
      this.props.loadAllVehicles && this.props.loadAllVehicles()
      this.props.onClose()
      return CustomNotification("success", "Success", "Vehicle details swapped successfully")
    } else return CustomNotification("danger", "Error", "Vehicle details swapped failed")
  }

  vehicleSearchOptions = FILTER_OPTIONS_VEHICLE.map((vehicle) => ({
    ...vehicle,
    text: vehicle.key
  }))

  searchByFromVehicle = (_, { value }) => {
    this.setState({ from_vehicle_search_by: value })
  }

  searchByToVehicle = (_, { value }) => {
    this.setState({ to_vehicle_search_by: value })
  }

  loadVehicles = async (payload, callback) => {
    this.setState({ loading: true })
    const { id } = this.props.fleet

    await this.props.dispatch({
      type: "VEHICLES_LOAD_SAGA",
      payload: {
        is_active: !this.state.showInactiveVehicles,
        pagination: true,
        page: 1,
        options: {
          fleet_id: id,
          saveVehiclesToState: false
        },
        ...payload
      },
      callback: callback
    })
  }

  onFromVehicleSelect = (vehicle_id) => {
    this.setState({
      from_vehicle_id: vehicle_id,
      from_vehicle: this.state.from_vehicles_list.find((v) => v.id === vehicle_id)
    })
  }

  onToVehicleSelect = (vehicle_id) => {
    this.setState({
      to_vehicle_id: vehicle_id,
      to_vehicle: this.state.to_vehicles_list.find((v) => v.id === vehicle_id)
    })
  }

  render() {
    const { open, t } = this.props

    const { from_vehicle, to_vehicle, loading, from_vehicle_search_by, to_vehicle_search_by } =
      this.state
    return (
      <Modal size="small" closeIcon open={open} onClose={this.handleClose}>
        <Modal.Content className="reassignment_vehicle">
          <Modal.Header className="reassignment_vehicle_modal_header">
            <strong>{t("vehicleReassignmentTitle")}</strong>
          </Modal.Header>
          <Modal.Description>
            <Grid verticalAlign="middle" textAlign="center" columns={5}>
              <Grid.Column width={3}>
                <Dropdown
                  onChange={this.searchByFromVehicle}
                  options={this.vehicleSearchOptions}
                  placeholder="Search By"
                  value={from_vehicle_search_by}
                  fluid
                  selection
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <AsyncSelect
                  loadOptions={(input, cb) => this.loadVehicleOptions(input, cb, "from")}
                  isLoading={loading}
                  placeholder={t("FromVehiclePlaceHolder")}
                  onChange={(selectedOption) => this.onFromVehicleSelect(selectedOption.value)}
                />
              </Grid.Column>

              <Grid.Column width={1}>
                <FontAwesomeIcon icon={faArrowRightLong} size="lg" style={{ marginTop: "10px" }} />
              </Grid.Column>
              <Grid.Column width={3}>
                <Dropdown
                  onChange={this.searchByToVehicle}
                  options={this.vehicleSearchOptions}
                  placeholder="Search By"
                  value={to_vehicle_search_by}
                  fluid
                  selection
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <AsyncSelect
                  loadOptions={(input, cb) => this.loadVehicleOptions(input, cb, "to")}
                  isLoading={loading}
                  placeholder={t("ToVehiclePlaceHolder")}
                  onChange={(selectedOption) => this.onToVehicleSelect(selectedOption.value)}
                />
              </Grid.Column>

              <Grid.Column width={8}>
                {from_vehicle && (
                  <Grid padded="horizontally" style={{ justifyContent: "end" }}>
                    <Grid.Column width={16}>
                      <p className="vehicle_field">
                        <span>
                          {" "}
                          {from_vehicle && from_vehicle.year
                            ? `${from_vehicle.year} ${from_vehicle.make} ${from_vehicle.model}`
                            : "-"}{" "}
                        </span>
                      </p>
                      <p className="vehicle_field">
                        {t("cardName")}: <span>{from_vehicle.name_of_vehicle || "-"}</span>
                      </p>
                      <p className="vehicle_field">
                        {t("departmentNumber")}:{" "}
                        <span>{from_vehicle.department_number || "-"}</span>
                      </p>
                    </Grid.Column>
                  </Grid>
                )}
              </Grid.Column>
              <Grid.Column width={8}>
                {to_vehicle && (
                  <Grid padded="horizontally">
                    <Grid.Column width={16}>
                      <p className="vehicle_field">
                        <span>
                          {" "}
                          {to_vehicle && to_vehicle.year
                            ? `${to_vehicle.year} ${to_vehicle.make} ${to_vehicle.model}`
                            : "-"}{" "}
                        </span>
                      </p>
                      <p className="vehicle_field">
                        {t("cardName")}: <span>{to_vehicle.name_of_vehicle || "-"}</span>
                      </p>
                      <p className="vehicle_field">
                        {t("departmentNumber")}: <span>{to_vehicle.department_number || "-"}</span>
                      </p>
                    </Grid.Column>
                  </Grid>
                )}
              </Grid.Column>
            </Grid>

            <p style={{ marginTop: "20px" }}>
              <strong>{t("vehicleReassignmentNoteHeading")}</strong>:{" "}
              {t("vehickeReassignmentNoteContent")}{" "}
            </p>
            <div
              className="connet-to-telematics-btn"
              style={{ width: "50%", margin: "50px auto 0 auto", cursor: "pointer" }}
            >
              <div className="btn-wrapper" onClick={() => this.vehicleReassignment()}>
                <div className="btn-text">{loading ? <MiniLoader /> : "Reassign"}</div>
              </div>
            </div>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  vehicles: state.vehicles.vehicles,
  fleet: state.application.fleetSessionData || state.fleets.fleet
})

export default connect(mapStateToProps)(withTranslation("vehicle")(VehicleReassignmentModal))
